module.exports = __webpack_public_path__ + "static/media/bd.73c177e4.svg";